// src/api/tokenStorage.ts
declare module 'js-cookie';
import Cookies from 'js-cookie';

/** @deprecated JWT больше не хранится в браузере - используйте сессию cookie my-session */
export const AUTH_TOKEN_KEY = 'authToken';
export const ROLE_KEY = 'myTeacherRole';
export const USER_ROLE_IDS_KEY = 'myTeacherRoleIds';

export enum Roles {
  tutor = 1,
  student = 2,
}

const getDomains = (): string[] => {
  if (typeof window === 'undefined') return [];
  if (window.location.hostname.includes('localhost')) {
    return ['localhost', '127.0.0.1'];
  }
  // Include bare hostname so host-only leftovers from older deploys are cleared.
  return [
    '.myteacher.pro',
    'myteacher.pro',
    'profile.myteacher.pro',
    window.location.hostname,
  ];
};

/** @deprecated Сессия в HttpOnly cookie; для проверки auth используйте useAuthSession */
export const getAuthToken = (): string | undefined => undefined;

/** @deprecated */
export const setAuthToken = (_token: string): void => {
  removeLegacyAuthToken();
};

/** Удаляет устаревший JS-readable JWT cookie после миграции на BFF */
export const removeLegacyAuthToken = (): void => {
  const domains = getDomains();
  domains.forEach((domain) => {
    Cookies.remove(AUTH_TOKEN_KEY, { domain, path: '/' });
  });
  Cookies.remove(AUTH_TOKEN_KEY, { path: '/' });
};

export const removeAuthToken = (): void => {
  removeLegacyAuthToken();
};

export const getRole = (): string | undefined => {
  return Cookies.get(ROLE_KEY);
};

export const setActiveRole = (roleId: number): void => {
  const roleDict = Roles[roleId as Roles];
  if (roleDict !== 'tutor' && roleDict !== 'student') {
    return;
  }

  const domains = getDomains();

  domains.forEach((domain) => {
    Cookies.set(ROLE_KEY, roleDict, {
      domain,
      expires: 7,
      path: '/',
      secure: process.env.NODE_ENV === 'production',
    });
  });

  Cookies.set(ROLE_KEY, roleDict, {
    expires: 7,
    path: '/',
    secure: process.env.NODE_ENV === 'production',
  });
};

export const hasDualRole = (roleIds: number[]): boolean => {
  return roleIds.includes(Roles.tutor) && roleIds.includes(Roles.student);
};

export const setUserRoleIds = (roleIds: number[]): void => {
  const domains = getDomains();
  const value = JSON.stringify(roleIds);

  domains.forEach((domain) => {
    Cookies.set(USER_ROLE_IDS_KEY, value, {
      domain,
      expires: 7,
      path: '/',
      secure: process.env.NODE_ENV === 'production',
    });
  });

  Cookies.set(USER_ROLE_IDS_KEY, value, {
    expires: 7,
    path: '/',
    secure: process.env.NODE_ENV === 'production',
  });
};

export const getUserRoleIds = (): number[] => {
  const raw = Cookies.get(USER_ROLE_IDS_KEY);
  if (!raw) return [];

  try {
    const parsed = JSON.parse(raw) as unknown;
    return Array.isArray(parsed)
      ? parsed.filter((id): id is number => typeof id === 'number')
      : [];
  } catch {
    return [];
  }
};

export const removeUserRoleIds = (): void => {
  const domains = getDomains();

  domains.forEach((domain) => {
    Cookies.remove(USER_ROLE_IDS_KEY, { domain, path: '/' });
  });

  Cookies.remove(USER_ROLE_IDS_KEY, { path: '/' });
};

/**
 * Persist active accent role cookie.
 * Do not mutate the roles array (.sort). Prefer preferredRoleId when present in roles;
 * otherwise first role as returned by API (do not keep a previous account's cookie).
 */
export const setRole = (role: Array<number>, preferredRoleId?: number | null): void => {
  const roles = Array.isArray(role) ? [...role] : [];
  if (!roles.length) {
    return;
  }

  let currentRole: number | undefined;
  if (preferredRoleId != null && roles.includes(preferredRoleId)) {
    currentRole = preferredRoleId;
  } else {
    currentRole = roles[0];
  }

  if (!currentRole) {
    return;
  }

  const roleDict = Roles[currentRole as Roles];
  if (roleDict !== 'tutor' && roleDict !== 'student') {
    return;
  }

  const domains = getDomains();
  domains.forEach((domain) => {
    Cookies.set(ROLE_KEY, roleDict, {
      domain,
      expires: 7,
      path: '/',
      secure: process.env.NODE_ENV === 'production',
    });
  });

  Cookies.set(ROLE_KEY, roleDict, {
    expires: 7,
    path: '/',
    secure: process.env.NODE_ENV === 'production',
  });
};

export const removeRole = (): void => {
  const domains = getDomains();

  domains.forEach((domain) => {
    Cookies.remove(ROLE_KEY, { domain, path: '/' });
  });

  Cookies.remove(ROLE_KEY, { path: '/' });
  removeUserRoleIds();
};
